Klient {{ ob | objectLabel: details.organizationClientId | async }} odwiedził

<a [routerLink]="['/lookbook/edit/', details.lookBookId, 'orders']">LookBook</a>
